<!--
* @Name：对账单基本信息
* @Author: 刘玉
* @Date: 2021-12-02 15:43:41
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:41
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.statementCode"></hi-cell>
    <hi-cell title="采购组：" :value="headInfo.purgrpName"></hi-cell>
    <hi-cell title="公司名称：" :value="headInfo.companyName"></hi-cell>
    <hi-cell title="供应商名称：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="未税总金额：" :value="headInfo.invoiceNoTaxAmount"></hi-cell>
    <hi-cell title="税额总金额：" :value="headInfo.invoiceTaxAmount"></hi-cell>
    <hi-cell title="价税合计：" :value="headInfo.invoicePriceTaxTotal"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyName"></hi-cell>
    <hi-cell title="对账单类型：" :value="headInfo.statementType" :options="statementTypeOptions"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    statementTypeOptions() {
      return this.$store.getters.dicts.statement_type
    }
  },
  watch: {},
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {}
}
</script>
